const submitQuestion = /* GraphQL */ `
  mutation SubmitAQuestion(
    $pageId: String!
    $questionText: String!
    $authorName: String!
    $email: String!
    $authorLocation: String
  ) {
    submitAQuestion(
      pageId: $pageId
      questionText: $questionText
      authorName: $authorName
      email: $email
      authorLocation: $authorLocation
    )
  }
`

export default submitQuestion
